import { Component, OnInit, Input, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { IKalenderData } from '../../dashboard/dashboard.service';
import { MenuService } from '../menu.service';
import { jumpToAnchor } from '../helpers';
import { of, Subject } from 'rxjs';

import { state2 } from '../state';
import { AppService } from '../app.service';
import { ActivatedRoute } from '@angular/router';
import { mergeMap } from 'rxjs/operators';
import { NgFor, NgIf, UpperCasePipe, DatePipe } from '@angular/common';

interface IZittingListViewState {
  zittingFragment?: string;
}

@Component({
    selector: 'app-zitting-list',
    templateUrl: './zitting-list.component.html',
    styleUrls: ['./zitting-list.component.scss'],
    standalone: true,
    imports: [NgFor, NgIf, UpperCasePipe, DatePipe]
})
export class ZittingListComponent implements OnInit  {

  viewState: IZittingListViewState;
  isRendered = new Subject<boolean>();

  private zittingenList: IKalenderData[];
  @Input()
  set zittingen(value: IKalenderData[]) { this.zittingenList = value; this.processZittingen(this.zittingenList); }
  get zittingen() { return this.zittingenList; }

  constructor(private appService: AppService, private route: ActivatedRoute, private menuService: MenuService) {
    this.isRendered.pipe(
      mergeMap(_ => route.fragment)
    ).subscribe(fragment => { jumpToAnchor(fragment); });
  }

  ngOnInit() {
    state2.getValueOrDefault<IZittingListViewState>('calendarstate', of({})).subscribe(state => this.viewState = state);
  }

  getZittingId = (index: number, zitting: IKalenderData) => zitting.Id;

  processZittingen(zittingen: IKalenderData[]) {
    if (!zittingen) { return; }
    let lastMonth = 0;
    let lastYear = 0;
    let zittingToView: IKalenderData = null;

    const huidigeMaand = new Date().getFullYear();
    const huidigeJaar = new Date().getMonth();

    zittingen.forEach(z => {
      z.DatumZitting = new Date(z.DatumZitting as string);
      z.identifier = `z_${z.Id}`;
      if (z.DatumZitting.getFullYear() === lastYear && z.DatumZitting.getMonth() === lastMonth) {
        z.IsMonthChanged = false;
        return;
      }
      z.IsMonthChanged = true;
      lastMonth = z.DatumZitting.getMonth();
      lastYear = z.DatumZitting.getFullYear();
      if (zittingToView == null && lastMonth >= huidigeMaand && lastYear >= huidigeJaar) {
        zittingToView = z;
      }

    });
    this.zittingenList = zittingen;
    this.isRendered.next(true);
  }

  navigateToDetailZitting(zitting: IKalenderData) {
    if (!zitting.NotificatieVerstuurd) { return; }
    this.menuService.setActiveMenu(null);
    this.appService.routing.setFragment(zitting.identifier);
    this.appService.routing.navigateToDetailZitting(zitting.Id);
  }


}
